import { pgEnum, pgTable, text } from "drizzle-orm/pg-core";
import { id } from "../../utils/sql";
import { unit } from "../../common/unit/unit.sql";
import { relations } from "drizzle-orm";
import type { Unit } from "@corpuscomplete/core/common/unit";
import type { NutrientKey } from "./constants";

export const nutrientType = pgEnum("nutrient_type", [
  "carbohydrate",
  "protein",
  "fat",
  "vitamin",
  "mineral",
  "other",
]);

export const nutrient = pgTable("nutrient", {
  ...id,
  defaultName: text("default_name").unique().notNull(),
  key: text("key").unique().$type<NutrientKey>(),
  unitKey: text("unit_key")
    .references(() => unit.key)
    .$type<Unit.Key>()
    .notNull(),
  type: nutrientType("type").notNull(),
});

export const nutrientRelations = relations(nutrient, ({ one }) => ({
  unit: one(unit, {
    fields: [nutrient.unitKey],
    references: [unit.key],
  }),
}));
